( function ( $ ) {

  const $trigger = $('#ll-trigger');
  if ( !$trigger.length ) { return; }

  const $list = $('#polls-list');
  let no_trigger = false;
  let page = 2;

  function load_more () {
    if ( no_trigger ) { return; }
    no_trigger = true;
    ThemeJS.Functions.wp_rest_request({
      endpoint: `ycw/poll-archive/${ page }`,
      success ( res ) {
        res.posts.forEach( ( post ) => {
          $list.append( post.html );
        });
        $(window).trigger( 'wpsp/init_all' );
        page++;
        if ( page > res.maxpage ) {
          $trigger.remove();
        }
      },
      error ( res ) {
        console.error( res );
      },
      complete () {
        no_trigger = false;
      },
    });
  }


  const observer = new IntersectionObserver(
    ( entries, obs ) => {
      if ( entries[0].isIntersecting ) {
        load_more();
      }
    },
    {
      rootMargin: '200px',
    }
  )

  observer.observe( $trigger.get(0) );



})( jQuery );